/**
 * Checking captcha before submitting the form
 * @param {JQuery} $form - current form
 * @param {Object} event - current event
 * @param {function} ajaxCallback - Callback function to call to backend side
 * @param {Object} options - additional options
 */
function checkCaptcha($form, event, ajaxCallback, options) {
    const sitekey = $form.data('sitekey'); // checking if recaptcha enabled and and placed in the form

    if (!sitekey || !window.grecaptcha) {
        if (ajaxCallback) {
            ajaxCallback($form, event, options);
        }

        return;
    }

    window.grecaptcha.ready(function () {
        window.grecaptcha.execute(sitekey, { action: 'submit' }).then(function (token) {
            $form.find('.js-recaptcha-response').val(token);

            if (ajaxCallback) {
                if (options) {
                    options.captchaToken = token;
                }

                ajaxCallback($form, event, options);
            } else {
                $form.data('sitekey', '');
                $form.find('button').click();
            }
        });
    });
}

module.exports = checkCaptcha;
